import React from 'react'
import ButtonGroup from '../../../components/ButtonGroup/image'
import buildImageUrl from '../../../../lib/media-url-maker'

const ImageButtonGroupWidget = ({ container: Container, items = [] }) => {
  items = items.map((item) => {
    item.src =
      item.images.widgets &&
      item.images.widgets.length &&
      buildImageUrl({
        height: 150,
        mode: 'cover',
        resource:
          item.images.widgets[0].crops &&
          item.images.widgets[0].crops[0] &&
          item.images.widgets[0].crops[0].src
      })

    return item
  })

  return (
    <Container my={[35]}>
      <ButtonGroup items={items} />
    </Container>
  )
}

export default ImageButtonGroupWidget
